export const componentIds = {
  AccordionItemHeader: 'AccordionItemHeader',
  AccordionItemBody: 'AccordionItemBody',
  AccordionItem: 'AccordionItem',
};
